import {decodeEntity} from 'html-entities';

function DeEscapeTxt(TxtIn: any)
{
    if ((typeof (TxtIn) !== 'undefined' && TxtIn !== null))
    {
        //var decode = require('decode-html');
        //return(decodeEntity(TxtIn));
        return TxtIn;
    }
    else
    {
        let s = "";
        return (s);
    }
}
export default DeEscapeTxt